export const getGA4ProductMandatoryFields = (event?: string): string[] => {
  if (!event) {
    return []
  }

  switch (event) {
    case 'add_to_cart':
      return addToCartMandatoryFields()
    case 'remove_from_cart':
      return removeFromCartMandatoryFields()
    case 'add_to_wishlist':
      return addToWishListMandatoryFields()
    case 'view_item_list':
      return viewItemListMandatoryFields()
    case 'select_item':
      return selectItemMandatoryFields()
    case 'view_item':
      return viewItemMandatoryFields()
    default:
      return []
  }
}

function addToCartMandatoryFields(): string[] {
  return [
    'item_name',
    'item_id',
    'price',
    'item_brand',
    'item_category',
    'item_list_name',
    'index',
    'quantity',
    'product_life_cycle',
    'weighted_average_score',
    'hasImage',
    'availability',
    'add_to_cart_order',
    'label',
    'has_variants',
    'variant_count',
    'unique_quantity',
  ]
}

function removeFromCartMandatoryFields(): string[] {
  return [
    'item_name',
    'item_id',
    'price',
    'item_brand',
    'item_category',
    'item_list_name',
    'index',
    'quantity',
    'product_life_cycle',
    'weighted_average_score',
    'hasImage',
    'availability',
    'add_to_cart_order',
    'label',
    'has_variants',
    'variant_count',
  ]
}

function addToWishListMandatoryFields(): string[] {
  return [
    'item_name',
    'item_id',
    'price',
    'item_brand',
    'item_category',
    'item_list_name',
    'index',
    'quantity',
    'product_life_cycle',
    'weighted_average_score',
    'hasImage',
    'availability',
    'label',
    'has_variants',
    'variant_count',
  ]
}

function viewItemListMandatoryFields(): string[] {
  return [
    'item_name',
    'item_id',
    'price',
    'item_brand',
    'item_category',
    'item_list_name',
    'index',
    'quantity',
    'product_life_cycle',
    'weighted_average_score',
    'hasImage',
    'availability',
    'label',
    'has_variants',
    'variant_count',
  ]
}

function selectItemMandatoryFields(): string[] {
  return [
    'item_name',
    'item_id',
    'price',
    'item_brand',
    'item_category',
    'item_list_name',
    'index',
    'quantity',
    'product_life_cycle',
    'weighted_average_score',
    'hasImage',
    'availability',
    'label',
    'has_variants',
    'variant_count',
  ]
}

function viewItemMandatoryFields(): string[] {
  return [
    'item_name',
    'item_id',
    'price',
    'item_brand',
    'item_category',
    'item_list_name',
    'index',
    'product_life_cycle',
    'weighted_average_score',
    'hasImage',
    'availability',
    'label',
    'has_variants',
    'variant_count',
  ]
}

export const getGA4ProductSkippableFields = (event?: string): string[] => {
  if (!event) {
    return []
  }

  const skippableFields: string[] = []

  switch (event) {
    case 'add_to_cart':
      skippableFields.push('index')
      break
    case 'remove_from_cart':
      skippableFields.push('index')
      break
    case 'add_to_wishlist':
      skippableFields.push('quantity')
      break
    case 'view_item_list':
      skippableFields.push('quantity')
      break
    case 'select_item':
      skippableFields.push('quantity')
      break
    case 'view_item':
      skippableFields.push('index', 'quantity')
      break
    default:
      break
  }

  return skippableFields
}
